<template>
  <div>
    <van-popup v-model="show" position="bottom" :style="{ height: '100%' }">
      <div class="title-box">
        选择优惠券
        <img
          src="../../../assets/images/common/icon-close.png"
          alt=""
          class="title-img"
          @click="close"
        />
      </div>
      <div class="body" v-if="couponslist != '' || notlist != ''">
        <div class="content">
          <!-- 优惠卷 -->
          <div v-for="(item, index) in couponslist" :key="index">
            <div class="coupons-box">
              <div class="box">
                <div class="money-box">
                  <div class="money" :class="isRepeat(item.id) ? 'not' : ''">
                    {{ item.value }}
                    <span v-if="item.type == 'disc'">折</span>
                    <span v-else>元</span>
                  </div>
                  <div class="money-txt" :class="isRepeat(item.id) ? 'not' : ''">
                    {{ item.type_name }}
                  </div>
                </div>
                <div class="content-box">
                  <div class="title" :class="isRepeat(item.id) ? 'not' : ''">
                    {{ item.name }}
                  </div>
                  <div class="time" :class="isRepeat(item.id) ? 'not' : ''">
                    有效期 {{ item.pd_from_date }}~{{ item.pd_to_date }}
                  </div>
                  <div class="explain-btn" @click="Jum_explain(index)" v-if="!isRepeat(item.id)">
                    使用规则
                    <img
                      src="../../../assets/images/common/list_down_arrow.png"
                      alt=""
                      class="explain-icon"
                    />
                  </div>
                </div>
                <div class="check-box">
                  <van-checkbox
                    v-if="!isRepeat(item.id)"
                    v-model="item.checked"
                    checked-color="#09BB07"
                    @change="onchange(item)"
                  ></van-checkbox>
                </div>
              </div>
              <div class="tipe-box" v-if="isRepeat(item.id)">
                <img
                  src="../../../assets/images/common/icon_youhuiquan_warm.png"
                  alt=""
                  class="tipe-img"
                />
                已选择不可叠加使用其他的优惠券
              </div>
            </div>
            <div class="explain-box" v-show="typeindex == index">
              {{ item.intro }}
            </div>
          </div>

          <!-- 不可使用优惠卷 -->
          <div v-if="notlist.length != 0">
            <div class="not-title">- 以下优惠券不可用 -</div>
            <div class="coupons-box" v-for="(item, index) in notlist" :key="index">
              <div class="box">
                <div class="money-box">
                  <div class="money not">
                    {{ item.value }}
                    <span>元</span>
                  </div>
                  <div class="money-txt not">{{ item.type_name }}</div>
                </div>
                <div class="content-box">
                  <div class="title not">{{ item.name }}</div>
                  <div class="time not">有效期 {{ item.pd_from_date }}~{{ item.pd_to_date }}</div>
                </div>
              </div>
              <div class="tipe-box">
                <img
                  src="../../../assets/images/common/icon_youhuiquan_warm.png"
                  alt=""
                  class="tipe-img"
                />
                改优惠券不可用于此订单
              </div>
            </div>
          </div>

          <div class="tipe-explain">
            <div class="explain-title">注意事项</div>
            <div class="explain-content">
              <p>1.在参与过程中如发现违规行为，平台有权利收回优惠券</p>
            </div>
            <div class="customer" v-if="!isMiniOpen">
              2如有疑问，请
              <a class="bule" :href="customer_info.url" target="_blank">联系客服</a>
            </div>
          </div>
        </div>
        <div class="bottom-box">
          <div class="txt">
            已选择
            <span>{{ seletlist.length }}</span>
            张优惠券
          </div>
          <div class="btn" @click="goToBill">确定</div>
        </div>
      </div>
      <div class="default" v-else>
        <img src="../../../assets/images/empty/coupons.png" alt="" class="default_img" />
        <p class="default_txt">暂无优惠卷~</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { orderservic } from '@/api/order'
import { ordercoupons } from '@/api/order'
import { getPaySuccessURL } from '@/utils/cookies'

export default {
  name: 'Coupons',
  props: ['show', 'orderPrepareParam', 'selectedCoupons'],
  data() {
    return {
      seletlist: [], //选中的优惠券
      couponslist: [], //可使用优惠券
      notlist: [], //不可使用优惠券
      typeindex: -1,
      allowSeletlist: [], // 允许选择的列表
      customer_info: [], //客服信息
      isMiniOpen: false,
    }
  },
  mounted() {
    this.getCouponsPrepare()
    this.getServicPrepare()
    this.isMiniOpen = getPaySuccessURL() === 'mpopen'
  },
  computed: {
    isRepeat() {
      return function (id) {
        return this.allowSeletlist.indexOf(id) === -1
      }
    },
  },
  methods: {
    // 关闭按钮
    close() {
      this.$emit('onClose')
    },
    Jum_explain(index) {
      console.log(index)
      if (index != this.typeindex) {
        this.typeindex = index
      } else {
        this.typeindex = -1
      }
    },
    getCouponsPrepare() {
      ordercoupons(this.orderPrepareParam).then((res) => {
        // 请求成功
        if (res.status === 1) {
          this.notlist = res.data.not_usable_list
          this.getCoupons(res.data.usable_list)
        } else {
          res.message && this.$toast(res.message)
        }
      })
    },
    getServicPrepare() {
      orderservic(this.orderPrepareParam).then((res) => {
        console.log(res)
        if (res.status === 1) {
          this.customer_info = res.data.customer_info
        } else {
          res.message && this.$toast(res.message)
        }
      })
    },
    onchange(item) {
      let selectId = item.id
      this.typeindex = -1
      if (item.checked) {
        this.seletlist.push(selectId)
      } else {
        let idIndex = this.seletlist.indexOf(selectId)
        this.seletlist.splice(idIndex, 1)
      }
      // console.log(this.seletlist);
      this.computedAllowSeletlist(selectId, item.superposition)
    },
    computedAllowSeletlist(selectId, superposition) {
      this.allowSeletlist = []
      if (this.seletlist.length === 0 || !selectId) {
        for (const element of this.couponslist) {
          this.allowSeletlist.push(element.id)
        }
        return false
      }

      if (superposition == 0) {
        this.allowSeletlist.push(selectId)
      } else {
        for (const element of this.couponslist) {
          if (element.superposition === 1) {
            this.allowSeletlist.push(element.id)
          }
        }
      }
    },
    goToBill() {
      this.$emit('update', this.seletlist)
      this.close()
    },
    getCoupons(couponslist) {
      if (this.selectedCoupons.length === 0) {
        this.couponslist = couponslist
        this.computedAllowSeletlist()
        return false
      }
      let selectedId, superposition
      this.seletlist = this.selectedCoupons
      for (let i = 0; i < couponslist.length; i++) {
        const id = couponslist[i].id
        if (this.seletlist.indexOf(id) >= 0) {
          superposition = couponslist[i].superposition
          selectedId = id
          couponslist[i].checked = true
        }
      }

      this.couponslist = couponslist
      this.computedAllowSeletlist(selectedId, superposition)
    },
  },
}
</script>
<style scoped>
.body {
  height: 100vh;
  background: #f7f8fa;
}

.title-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 1.173rem;
  line-height: 0.667rem;
  opacity: 0.9;
  font-size: 0.4rem;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  color: #22242d;
  background: #ffffff;
  position: relative;
}

.title-img {
  position: absolute;
  top: 0.32rem;
  right: 0.533rem;
  width: 0.533rem;
  height: 0.533rem;
}

.content {
  background: #f7f8fa;
  padding: 0 0.533rem;
  overflow: hidden;
}

.coupons-box {
  width: 8.933rem;
  background: #ffffff;
  border-radius: 0.213rem;
  box-shadow: 0 0.133rem 0.267rem 0 rgba(24, 25, 26, 0.05);
  padding: 0.56rem 0 0.507rem;
  margin: 0 auto;
  margin-top: 0.533rem;
}

.box {
  display: flex;
}

.money {
  width: 2.454rem;
  font-size: 0.8rem;
  line-height: 0.96rem;
  font-family: DIN, DIN-Bold;
  font-weight: 700;
  text-align: center;
  color: #ff6a4d;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.money span {
  font-size: 0.32rem;
  line-height: 0.427rem;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 600;
  text-align: center;
  color: #ff6a4d;
  margin-left: 0.08rem;
}

.money-txt {
  font-size: 0.293rem;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 600;
  text-align: center;
  color: #ff6a4d;
}

.title {
  width: 5rem;
  font-size: 0.373rem;
  line-height: 0.533rem;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  color: #22242e;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.time {
  font-size: 0.293rem;
  line-height: 0.427rem;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 560;
  color: #3c3d42;
  margin-top: 0.08rem;
}

.explain-btn {
  /* display: flex; */
  align-content: center;
  font-size: 0.293rem;
  line-height: 0.427rem;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 600;
  color: #919499;
  margin-top: 0.08rem;
}

.explain-icon {
  width: 0.213rem;
  height: 0.133rem;
  display: inline;
  margin-left: 0.107rem;
  margin-top: 0.15rem;
}

.check-box {
  display: flex;
  align-items: center;
  margin-left: 0.5rem;
}

.not {
  color: #c2c5cc;
}

.not span {
  color: #c2c5cc;
}

.not-title {
  font-size: 0.32rem;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 600;
  text-align: center;
  color: #22242e;
  margin-top: 0.533rem;
}

.tipe-box {
  width: 8.507rem;
  font-size: 0.293rem;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 600;
  line-height: 0.427rem;
  color: #919499;
  border-top: 0.013px dashed #ebecf0;
  margin: 0.267rem auto 0;
  padding-top: 0.2rem;
}

.tipe-img {
  width: 0.32rem;
  height: 0.32rem;
  margin: 0 0.133rem;
}

.explain-box {
  width: 8.079rem;
  font-size: 0.293rem;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  color: #919499;
  background: #ffffff;
  padding: 0.373rem 0.427rem;
  box-shadow: 0 0.133rem 0.267rem 0 rgba(24, 25, 26, 0.05) inset;
}

.explain-title {
  font-size: 0.373rem;
  line-height: 0.533rem;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  color: #22242e;
  margin-top: 0.533rem;
}

.explain-content {
  margin-top: 0.32rem;
}

.explain-content p {
  font-size: 0.32rem;
  line-height: 0.453rem;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  color: #919499;
}

.bule {
  color: #448aff;
}

.bottom-box {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 0.213rem 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.txt {
  font-size: 0.347rem;
  line-height: 0.48rem;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  color: #333333;
  margin-left: 0.533rem;
}

.txt span {
  color: var(--main-color);
  margin: 0 0.08rem;
}

.btn {
  width: 3.573rem;
  height: 0.96rem;
  font-size: 0.373rem;
  line-height: 0.96rem;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: center;
  color: #ffffff;
  background: var(--main-color);
  border-radius: 0.48rem;
  margin-right: 0.533rem;
}

.tipe-explain {
  width: 8.507rem;
  margin: 0 auto;
  margin-bottom: 2.207rem;
}

.default {
  height: 100vh;
  background: #fff;
  overflow: hidden;
}

.default_img {
  width: 4.053rem;
  height: 4.053rem;
  display: block;
  margin: 4.454rem auto 0;
}

.default_txt {
  font-size: 0.373rem;
  line-height: 0.533rem;
  font-weight: 500;
  text-align: center;
  color: #919499;
}

.customer {
  font-size: 0.32rem;
  line-height: 0.453rem;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  color: #919499;
  /* margin-top: 0.533rem; */
}
</style>
